import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

// COMPONENTES DE SISEF
import SisefTipoSolicitudes from "./sisef/SisefTipoSolicitudes";
import Sisef_Syllabus from './Sisef_Syllabus';
import { TIPOS_SISEF } from "./helper";
import { SisefMenu } from "./sisef/MenuSisef";
import Sisef_Rubrica from './Sisef_Rubrica';
import Sisef_Desempenos from './Sisef_Desempenos';
import Sisef_Gestion from './gestion/Sisef_Gestion';

// COMPONENTES GENERALES
import { mostrarModulo } from "../../redux/actions/actGlobal";
import { consulta, obtenerValoresFiltros } from "../../global/js/funciones";
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from './../../global/imagenes/emma_w.png';
import Listar_Asignaturas from './gestion/Listar_Asignaturas';
import Sisef_Seguimiento from './Sisef_Seguimiento';
import SisefEstudiante from './SisefEstudiante';
import MentoraPlaneador from './MentoraPlaneador';

const styles = theme => ({
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
    maxWidth: 750,
    margin: '60px auto 40px',
    padding: '0 32px',
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1400,
      flexWrap: 'nowrap',
      justifyContent: 'center',
      padding: '0 48px',
    },
  },
});

class Sisef extends Component {

  constructor(props) {
    super(props);
    this.state = {
      seleccion: 'miproceso_ini',
      cargando: true,
      nuevo: true,
      mensaje: '',
      tipos: [],
      tipoSolicitud: {},
      administrador: false,
      instructivo: [],
    };
    this.toggleDialog = this.toggleDialog.bind(this);
  }

  async componentDidMount() {
    const { mostrarModulo } = this.props;
    mostrarModulo({ rutas: 'mentora', nombre: 'Mentora' });
    this.obtenerDatosIniciales();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { seleccion } = this.state;
    if (prevState.seleccion !== seleccion) {
      if (seleccion === 'administrar') this.setState({ nuevo: true });
    }
  }

  async asignarAsigDocenteAuto() {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/asignaturas_docente_auto`,
        null,
        null,
        (error, estado, resp) => {
          resolve(estado === 200 && !error ? resp : null);
        }
      );
    });
  }

  cambiarEstado = (estados) => {
    this.setState(estados);
  };

  cambiarOpcion = (seleccion) => {
    this.cambiarEstado({ seleccion });
  };

  toggleDialog(toggle) {
    const { modal, value } = toggle;
    this.setState({ [modal]: value });
  }

  async obtenerDatosIniciales() {
    const { usuario } = this.props;
    let admin = false;
    if (usuario && usuario.perfil &&
      (usuario.perfil.codigo === "Per_Adm" ||
        usuario.perfil.codigo === "coor_area_sisef")
    ) {
      admin = true;
      this.setState({ administrador: true });
    }
    if (usuario && usuario.perfil && usuario.perfil.codigo === "Per_Doc") {
      await this.asignarAsigDocenteAuto();
    }
    this.setState({ cargando: true });
    let mensaje = "Estas en el proceso";
    let tipos = [];
    let instructivo = await obtenerValoresFiltros([
      { llave: "codigo", valor: "Instru_Mentora" }, { llave: 'estado', valor: '1' }
    ]);
    this.setState({ instructivo: instructivo ? instructivo : [] });
    if (admin) {
      tipos = await obtenerValoresFiltros([
        { llave: 'generica', valor: TIPOS_SISEF },
        { llave: 'estado', valor: '1' },
        { llave: 'valorb', valor: '1' },
        { llave: 'valorf', valor: 'gestores' },
      ]);
    } else {
      tipos = await obtenerValoresFiltros([
        { llave: 'generica', valor: TIPOS_SISEF },
        { llave: 'estado', valor: '1' },
        { llave: 'valorb', valor: '1' },
        { llave: 'valore', valor: 'docente' },
        // { llave: 'valorf', valor: 'gestores' },
      ]);
    }
    this.setState({
      tipos: tipos.sort((a, b) => a.valora - b.valora),
      mensaje,
      cargando: false,
    });
  }

  vista = () => {
    const { seleccion } = this.state;
    switch (seleccion) {
      case 'miproceso_ini':
        return this.pintarOpciones();
      case 'administrar':
        return this.pintarAdministrar();
      case 'sol_syll':
        return this.pintarSyllabus();
      case 'sol_doc_rub':
        return this.pintarRubrica();
      case 'sol_desemp':
        return this.pintarDesempeño();
      case 'sol_rep_des':
        return this.pintarReportes();
      case 'sisef_seguimiento':
        return this.pintarSegumiento();
      case 'plan_doc':
        return <MentoraPlaneador cambiarOpcion={(value) => this.cambiarOpcion(value)} />;
      default:
        return null;
    }
  };

  pintarOpciones = () => {
    const { tipos } = this.state;
    const { classes } = this.props;

    const tipoSeleccion = tipo => {
      this.setState({ tipoSolicitud: tipo });
      switch (tipo.codigo) {
        case 'sol_syll': this.setState({ seleccion: "sol_syll" }); break;
        case 'sol_desemp': this.setState({ seleccion: "sol_desemp" }); break;
        case 'sol_doc_rub': this.setState({ seleccion: "sol_doc_rub" }); break;
        case 'sol_rep_des': this.setState({ seleccion: "sol_rep_des" }); break;
        case 'sisef_seguimiento': this.setState({ seleccion: "sisef_seguimiento" }); break;
        case 'plan_doc': this.setState({ seleccion: "plan_doc" }); break;
        default: break;
      }
    };

    return (
      <>
        {tipos.length > 0 ? (
          <div className={classes.cardsContainer}>
            {tipos.map((tipo) => (
              <SisefTipoSolicitudes
                key={tipo.codigo}
                data={tipo}
                image={tipo.archivo}
                onClick={() => tipoSeleccion(tipo)}
              />
            ))}
          </div>
        ) : (
          <TareasTerminadas
            mensaje="Cargando ..."
            marginTop="7%"
            imagen={emma_w}
            widthImg="7%"
            cargando={true}
          />
        )}
      </>
    );
  };

  pintarAdministrar() {
    const { administrador } = this.state;
    return (
      <div>
        <Sisef_Gestion administrador={administrador} />
      </div>
    );
  }

  pintarReportes() {
    return (
      <div>
        <Listar_Asignaturas />
      </div>
    );
  }

  pintarSegumiento() {
    return (
      <div>
        <Sisef_Seguimiento />
      </div>
    );
  }

  pintarSyllabus() {
    const { tipoSolicitud, administrador } = this.state;
    return (
      <div>
        <Sisef_Syllabus
          tipoSolicitud={tipoSolicitud}
          administrador={administrador}
        />
      </div>
    );
  }

  pintarRubrica() {
    const { tipoSolicitud } = this.state;
    return (
      <div>
        <Sisef_Rubrica tipoSolicitud={tipoSolicitud} />
      </div>
    );
  }

  pintarDesempeño() {
    const { tipoSolicitud, administrador } = this.state;
    return (
      <div>
        <Sisef_Desempenos tipoSolicitud={tipoSolicitud} administrador={administrador} />
      </div>
    );
  }

  render() {
    const { cargando, seleccion, administrador, instructivo } = this.state;
    const centrarContenido = seleccion === "miproceso_ini";
    const styleContenido = centrarContenido ? { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 180px)' } : {};
    return (
      seleccion === "miproceso_ini" || seleccion === "administrar" ? (
        <div>
          <SisefMenu
            sele={seleccion}
            seleccionar={(sel) => this.cambiarOpcion(sel)}
            estudiante={!administrador}
            instructivo={instructivo[0] ? instructivo[0].archivo : ''}
          />
          <div className="contenido_modulo" style={styleContenido}>
            {!cargando ? (
              this.vista()
            ) : (
              <TareasTerminadas
                mensaje="Cargando.."
                marginTop="7%"
                imagen={emma_w}
                widthImg="7%"
                cargando={true}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          {!cargando ? (
            this.vista()
          ) : (
            <TareasTerminadas
              mensaje="Cargando.."
              marginTop="7%"
              imagen={emma_w}
              widthImg="7%"
              cargando={true}
            />
          )}
        </div>
      )
    );
  }
}

const mapStateToProps = state => {
  const { usuario } = state.redGlobal;
  const { ModalAdd } = state.redSisef;
  return { usuario, ModalAdd };
};

const mapDispatchToProps = {
  mostrarModulo,
};

Sisef.propTypes = {
  usuario: PropTypes.object,
  ModalAdd: PropTypes.bool.isRequired,
  mostrarModulo: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Sisef));
